export default "__VITE_ASSET__B5tw7RfF__"